import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import StyledShopMobileMenuFlower from "./ShopMobileMenuFlower.styled";
import StyledShopMobileButtonFlower from "./ShopMobileButtonFlower.styled";
import SVGIcon from "../utility/SVGIcon";
import Button from "../ui/Button";
import Spinner from "../Spinner/Spinner";

const ShopMobileMenuFlower = React.memo((props) => {
  const {
    productPrice,
    categories,
    brands,
    total,
    selected,
    clearFilter,
    select,
    productType,
    thc,
    shopByForm,
    shopByPersona,
    discovers,
    shopByPotency,
    loading,
    className
  } = props;
  const [clicked, setClicked] = useState(false);
  const toggleMenu = () => {
    setClicked(!clicked);
    document.body.classList.remove("no-scroll");
  }

  useEffect(() => {
    clicked && document.body.classList.add("no-scroll")
  });

  return (
    <>
      <StyledShopMobileButtonFlower>
        <div className="shop-mobile-button__sort">{select}</div>
        <button
          className={`shop-mobile-button__filter ${selected > 0 && "t-bold"}`}
          onClick={toggleMenu}
        >
          FILTER
        </button>
      </StyledShopMobileButtonFlower>

      <StyledShopMobileMenuFlower data-menu-state={clicked} className={className}>
        <div
          className="shop-mobile-menu__background"
          onClick={toggleMenu}
        />
        <nav className="shop-mobile-menu__nav">
          <div className="shop-mobile-menu__nav__header">
            <button className="shop-mobile-menu__close" onClick={toggleMenu}>
              <SVGIcon name="close" />
              <span className="t-hidden">close menu</span>
            </button>
            <h2 className="t-hidden shop-mobile-menu__nav__heading">FILTERS</h2>
            <button
              className="t-bold shop-mobile-menu__nav__clear"
              onClick={clearFilter}
            >
              CLEAR ALL<span className="t-hidden">Filters</span>
            </button>
          </div>
          <div className="shop-mobile-menu__nav__filters">
            {loading && <div className="filter_loading">
              <Spinner color='var(--color-brand)' size={60} className="placeholder__loading"/>
            </div>}

            {discovers && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Discover
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {discovers}
                </div>
              </>
            )}

            {categories && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Category
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {categories}
                </div>
              </>
            )}

            {/* {featuredBrands && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Featured Brands
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {featuredBrands}
                </div>
              </>
            )} */}

            {brands && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Brand
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {brands}
                </div>
              </>
            )}

            {productType && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Lineage
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {productType}
                </div>
              </>
            )}

            {thc && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  THC Potency
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {thc}
                </div>
              </>
            )}

            {/*{subCategories && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Product Type
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {subCategories}
                </div>
              </>
            )}*/}

            {shopByForm && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Category
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {shopByForm}
                </div>
              </>
            )}

            {shopByPotency && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Potency
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {shopByPotency}
                </div>
              </>
            )}

            {shopByPersona && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Personality
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {shopByPersona}
                </div>
              </>
            )}

            {productPrice && (
              <>
                <h3 className="t-aside-heading shop-mobile-menu__filter-heading">
                  Price
                </h3>
                <div className="shop-mobile-menu__nav__wrapping-types">
                  {productPrice}
                </div>
              </>
            )}
          </div>
          <div className="shop-mobile-menu__nav__show-results">
            <Button onClick={toggleMenu}>SHOW {total} RESULTS</Button>
          </div>
        </nav>
      </StyledShopMobileMenuFlower>
    </>
  );
});

ShopMobileMenuFlower.propTypes = {
  className: PropTypes.string,
  total: PropTypes.number,
  selected: PropTypes.number,
  clearFilter: PropTypes.func,
};

export default ShopMobileMenuFlower;
